import React from "react";
import { motion } from "framer-motion";
import { Globe2, Quote } from "lucide-react";
import { OVERSEAS_REVIEWS } from "./kvpData";
import KvpLayout, { CHARCOAL, COPPER, CREAM, SLATE } from "./KvpLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function KvpOverseasClients() {
  return (
    <KvpLayout active="overseas">
      <section className="py-16 sm:py-20" style={{ background: CHARCOAL }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <Globe2 size={30} style={{ color: "#E39A6E" }} className="mx-auto mb-4" />
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#E39A6E" }}>For Overseas Clients</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">Handled Remotely, Without Losing Clarity</motion.h1>
          <motion.p {...fadeUp} className="mt-5 text-white/70 max-w-xl mx-auto text-sm">Overseas Filipinos and international clients have worked with us entirely online — property matters, business concerns and consultations handled without an in-person meeting.</motion.p>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-6">
          {OVERSEAS_REVIEWS.map((r) => (
            <motion.div key={r.author} {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm">
              <Quote size={20} style={{ color: COPPER }} className="mb-2" />
              <p className="text-sm" style={{ color: CHARCOAL }}>"{r.quote}"</p>
              <p className="mt-3 text-xs" style={{ color: SLATE }}>— {r.author}, Lawzana review, {r.date}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </KvpLayout>
  );
}
